export class Errors {
    public static readonly COMMON = 'An error has occured. Please try again later';
}
